import React from "react";
import { Table } from "react-bootstrap";

import classNames from "classnames";

import { capitalize } from "@lib/utils";

import { useRosterContext } from "@Clubhouse/components/Roster/contexts/Roster";
import isPlayoffEligible from "@Clubhouse/components/Roster/lib/isPlayoffEligible";

const OpposingCoachView = (): React.JSX.Element => {
    let {
        roster,
        currentTeam,
        currentTeamsLeague,
        currentTeamAgeLevel,
        currentYear,
        playoffEligibileDate,
    } = useRosterContext();

    return (
        <Table
            data-testid="opposingCoachView"
            striped
            className={classNames("teamRoster")}
            responsive
        >
            <thead>
                <tr>
                    <th>Name</th>
                    <th>#</th>
                    <th>Primary Team?</th>
                    <th>Playoff Eligible</th>
                </tr>
            </thead>
            <tbody>
                {roster.map(p => {
                    return (
                        <tr key={p.id}>
                            <td>{`${p.firstName} ${capitalize(p.lastName)[0]}.`}</td>
                            <td width={"16%"}>{p.uniformNumber}</td>
                            <td width={"16%"}>
                                {p.teams.find(t => {
                                    if (currentTeamsLeague) {
                                        return (
                                            t.year ===
                                                currentTeamsLeague.year &&
                                            t.season ===
                                                currentTeamsLeague.season.id
                                        );
                                    } else if (currentTeamAgeLevel) {
                                        return (
                                            t.year ===
                                                currentTeamAgeLevel.year &&
                                            t.season ===
                                                currentTeamAgeLevel.season.id
                                        );
                                    }
                                })?.primary?.id === currentTeam?.id
                                    ? "Yes"
                                    : "No"}
                            </td>
                            <td width={"16%"}>
                                {isPlayoffEligible(
                                    p,
                                    currentYear,
                                    playoffEligibileDate,
                                )
                                    ? "Yes"
                                    : "No"}
                            </td>
                        </tr>
                    );
                })}
            </tbody>
        </Table>
    );
};

export default OpposingCoachView;
